module.exports = __webpack_public_path__ + "img/carousel-4.dca360ad.png";